import React, { useContext } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { styled } from '@material-ui/core';
import LanguageContext from '../../../contexts/languageContext';

export const CheckBoxIcon = styled('span')(({ theme }) => ({
    borderRadius: 4,
    width: 15,
    height: 15,
    boxShadow:
        theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5'
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        border: '1px solid #989ea3',
        opacity: '0.5'

        // background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)'
    }
}));

export const CheckedIcon = styled(CheckBoxIcon)({
    backgroundColor: '#509ffa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 15,
        height: 15,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
        border: '1px solid transparent',
        outline: '2px auto transparent',
        borderRadius: 4
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3'
    }
});
const style = makeStyles({
    container: {
        width: '171px',
        padding: '16px',
        borderRadius: '6px',
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1.5px #f5f8fa',
        backgroundColor: '#fff',
        '& > *': {
            fontSize: '13px'
        }
    },
    checkBoxWrapper: ({ rtl }) => ({
        // justifyContent: 'space-between',
        margin: '0 -8px',
        direction: rtl ? 'rtl' : 'ltr'
    })
});

const CheckBox = ({ title, name, value, disabled, handleChange, ...props }) => {
    const { lang } = useContext(LanguageContext);
    const classes = style({ rtl: lang === 'fa' });

    return (
        <>
            <FormControlLabel
                className={classes.checkBoxWrapper}
                disabled={disabled}
                control={
                    <Checkbox
                        sx={{
                            '&:hover': { bgcolor: 'transparent' }
                        }}
                        disableRipple
                        color="default"
                        name={name}
                        value={name}
                        checkedIcon={<CheckedIcon />}
                        icon={<CheckBoxIcon />}
                        checked={value}
                        onChange={handleChange}
                        inputProps={{ 'aria-label': 'Checkbox demo' }}
                        {...props}
                    />
                }
                label={title}
            />
        </>
    );
};

CheckBox.propTypes = {
    value: PropTypes.bool,
    title: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    handleChange: PropTypes.function
};

export default CheckBox;
